export default "__VITE_ASSET__BPMuuY35__"